import HeroIcon from "./HeroIcon";
import { Workflow } from "./interface";
import { useTranslation } from "react-i18next";
import { ChevronRightIcon } from "@heroicons/react/outline";

interface Props {
  workflow: Workflow;
  onSelect: (workflow: Workflow) => void;
}

function InstantWorkflowCard(props: Props) {
  const { t } = useTranslation();
  const { workflow } = props;

  return (
    <div className="flex flex-col gap-2 border cursor-pointer p-4 rounded w-1/3 flex-shrink-0" onClick={() => props.onSelect(workflow)}>
      <div className="flex items-center justify-between gap-2">
        <div className="truncate font-semibold font-gilroy text-sm">
          {workflow.name}
        </div>
        <HeroIcon icon={workflow.icon} className="w-6 h-6 flex-shrink-0" />
      </div>
      <div className="text-xs text-gray-400">
        {workflow.description}
      </div>
      <div className="text-xs text-gray-600 font-semibold flex items-center gap-1 mt-auto">
        {t("Use workflow")}
        <ChevronRightIcon className="w-4 h-4" />
      </div>
    </div>
  )
}

export default InstantWorkflowCard;
